import { Music, User } from "lucide-react";
import { T, WORSHIP_TEAM } from "@/i18n";

export const Worship = ({ lang }) => {
  return (
    <section id="worship" data-testid="worship-section" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <p data-testid="worship-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
          {T.worship.sub[lang]}
        </p>
        <h2 data-testid="worship-heading" className={`mt-3 flex items-center justify-center gap-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
          <Music className="h-8 w-8 text-[#FFE500]" /> {T.worship.heading[lang]}
        </h2>
        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {WORSHIP_TEAM.map((name, i) => (
            <div key={name} data-testid={`worship-card-${i}`} className={`gc-card-sheen gc-fade-up gc-stagger-${i + 1} rounded-2xl p-5 text-center`}>
              <div className="gc-photo-placeholder mx-auto flex aspect-square flex-col items-center justify-center rounded-xl border border-dashed border-[#FFE500]/20">
                <User className="h-12 w-12 text-white/20" strokeWidth={1} />
                <span className="mt-2 px-3 text-[10px] uppercase tracking-widest text-white/40">
                  Official photograph coming soon
                </span>
              </div>
              <h3 data-testid={`worship-name-${i}`} className="mt-4 font-display text-lg font-bold uppercase tracking-wide text-white">
                {name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
